export class HttpConfig {
    baseUri: string;
    authorization?: {
        headerName: string;
        tokenPrefix: string;
    };
    globalHeaders?: { [key: string]: string };
}
